/** Pure utility — usable in both Server and Client Components */
export function groupByRoute(deals) {
  try {
    const groups = {}
    for (const d of deals) {
      const k = `${(d.origin ?? '').trim().toUpperCase()}-${(d.destination ?? '').trim().toUpperCase()}`
      if (!groups[k]) groups[k] = []
      groups[k].push(d)
    }
    const seen = new Set()
    const result = []
    for (const d of deals) {
      const k = `${(d.origin ?? '').trim().toUpperCase()}-${(d.destination ?? '').trim().toUpperCase()}`
      if (seen.has(k)) continue
      seen.add(k)
      const all = groups[k]
      if (all.length === 1) { result.push(d); continue }

      const minPrice = all.reduce((m, x) => Math.min(m, x.price ?? Infinity), Infinity)
      const base = all.find(x => x.price === minPrice) ?? all[0]

      const allDates = all.flatMap(x => {
        if (Array.isArray(x.departure_dates) && x.departure_dates.length > 0) return x.departure_dates
        if (x.departureDate) return [{ date: x.departureDate, returnDate: x.returnDate ?? null, price: x.price, id: x.id, airline: x.airline ?? null, stops: x.stops ?? null }]
        return []
      })
      const allMonths = [...new Set(allDates.map(d => parseInt(d.date.split('-')[1], 10)))].sort((a, b) => a - b)

      const mergedPriceByMonth = {}
      for (const x of all) {
        for (const [m, p] of Object.entries(x.priceByMonth ?? {})) {
          if (mergedPriceByMonth[m] == null || p < mergedPriceByMonth[m]) mergedPriceByMonth[m] = p
        }
      }

      result.push({
        ...base,
        price: minPrice,
        price_from: minPrice,
        date_count: allDates.length || all.length,
        departure_dates: allDates,
        departure_months: allMonths,
        priceByMonth: mergedPriceByMonth,
        _grouped: all.length,
      })
    }
    return result
  } catch (e) {
    console.error('[groupByRoute error]', e)
    return deals
  }
}
